import { Link } from "react-router-dom";
import { useState } from "react";
import SingleBlog from "../../components/Blog";
import Cookies from "js-cookie";

const NewsSection = ({
  news,
  handleNext,
  handlePrev,
  hasMore,
  isFetchingNextPage,
  pageIndex,
  totalFetchedPages,
}) => {
  const [activeTab, setActiveTab] = useState("public"); // Default to public

  const [auth, setAuth] = useState(() => {
    const token = Cookies.get("token");
    const role = Cookies.get("role");
    const email = Cookies.get("email");
    return { token, role, email };
  });
  const isAuthenticated = !!(auth?.token && auth?.role && auth?.email);

  const getFilteredNews = () => {
    if (!isAuthenticated) {
      return news.filter((item) => item.visibility === "public");
    }

    switch (activeTab) {
      case "public":
        return news.filter((item) => item.visibility === "public");
      case "private":
        return news.filter((item) => item.visibility === "private");
      case "all":
      default:
        return news;
    }
  };

  const filteredNews = getFilteredNews();
  const canGoNext = pageIndex + 1 < totalFetchedPages || hasMore;
  const canGoPrev = pageIndex > 0;

  // Calculate counts for tabs
  const allCount = news.length;
  const publicCount = news.filter(
    (item) => item.visibility === "public"
  ).length;
  const privateCount = news.filter(
    (item) => item.visibility === "private"
  ).length;

  const tabStyle = {
    borderRadius: "25px",
    padding: "8px 20px",
    fontWeight: "500",
    fontSize: "14px",
    border: "2px solid #e9ecef",
    marginRight: "8px",
    transition: "all 0.3s ease",
    textDecoration: "none",
    display: "inline-block",
    cursor: "pointer",
  };

  const activeTabStyle = {
    ...tabStyle,
    backgroundColor: "#007bff",
    color: "white",
    border: "2px solid #007bff",
    boxShadow: "0 2px 8px rgba(0, 123, 255, 0.3)",
  };

  const inactiveTabStyle = {
    ...tabStyle,
    backgroundColor: "white",
    color: "#6c757d",
    border: "2px solid #e9ecef",
  };

  return (
    <div className="it-blog-area pt-50">
      <div className="container">
        {/* Header Section */}
        <div className="row mb-20">
          <div className="col-12">
            <div className="text-center">
              <h2 className="mb-3" style={{ fontWeight: "600", color: "#333" }}>
                Latest News & Updates
              </h2>
              {!isAuthenticated && (
                <p className="text-muted mb-20">
                  Browse our latest public articles and updates
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="row mb-20">
          <div className="col-12">
            <div className="d-flex justify-content-center align-items-center flex-wrap">
              <button
                type="button"
                style={
                  activeTab === "public" ? activeTabStyle : inactiveTabStyle
                }
                onClick={() => setActiveTab("public")}
                onMouseEnter={(e) => {
                  if (activeTab !== "public") {
                    e.target.style.backgroundColor = "#f8f9fa";
                    e.target.style.borderColor = "#007bff";
                    e.target.style.color = "#007bff";
                  }
                }}
                onMouseLeave={(e) => {
                  if (activeTab !== "public") {
                    e.target.style.backgroundColor = "white";
                    e.target.style.borderColor = "#e9ecef";
                    e.target.style.color = "#6c757d";
                  }
                }}
              >
                Public
                <span
                  style={{
                    backgroundColor:
                      activeTab === "public"
                        ? "rgba(255,255,255,0.3)"
                        : "#e9ecef",
                    padding: "2px 8px",
                    borderRadius: "12px",
                    marginLeft: "8px",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  {publicCount}
                </span>
              </button>

              {isAuthenticated && (
                <>
                  <button
                    type="button"
                    style={
                      activeTab === "private"
                        ? activeTabStyle
                        : inactiveTabStyle
                    }
                    onClick={() => setActiveTab("private")}
                    onMouseEnter={(e) => {
                      if (activeTab !== "private") {
                        e.target.style.backgroundColor = "#f8f9fa";
                        e.target.style.borderColor = "#007bff";
                        e.target.style.color = "#007bff";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (activeTab !== "private") {
                        e.target.style.backgroundColor = "white";
                        e.target.style.borderColor = "#e9ecef";
                        e.target.style.color = "#6c757d";
                      }
                    }}
                  >
                    Private
                    <span
                      style={{
                        backgroundColor:
                          activeTab === "private"
                            ? "rgba(255,255,255,0.3)"
                            : "#e9ecef",
                        padding: "2px 8px",
                        borderRadius: "12px",
                        marginLeft: "8px",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      {privateCount}
                    </span>
                  </button>

                  <button
                    type="button"
                    style={
                      activeTab === "all" ? activeTabStyle : inactiveTabStyle
                    }
                    onClick={() => setActiveTab("all")}
                    onMouseEnter={(e) => {
                      if (activeTab !== "all") {
                        e.target.style.backgroundColor = "#f8f9fa";
                        e.target.style.borderColor = "#007bff";
                        e.target.style.color = "#007bff";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (activeTab !== "all") {
                        e.target.style.backgroundColor = "white";
                        e.target.style.borderColor = "#e9ecef";
                        e.target.style.color = "#6c757d";
                      }
                    }}
                  >
                    All News
                    <span
                      style={{
                        backgroundColor:
                          activeTab === "all"
                            ? "rgba(255,255,255,0.3)"
                            : "#e9ecef",
                        padding: "2px 8px",
                        borderRadius: "12px",
                        marginLeft: "8px",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      {allCount}
                    </span>
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
        {/* Status Bar - Now positioned below tabs */}
        <div className="row mb-20">
          <div className="col-12">
            <div className="d-flex justify-content-start align-items-center">
              <div
                style={{
                  backgroundColor: "#f8f9fa",
                  padding: "8px 16px",
                  borderRadius: "20px",
                }}
              >
                <small style={{ color: "#6c757d", fontWeight: "500" }}>
                  <i
                    className="fa-solid fa-newspaper me-2"
                    style={{ color: "#007bff" }}
                  ></i>
                  {isAuthenticated
                    ? `Showing ${filteredNews.length} ${
                        activeTab === "all"
                          ? "articles (all)"
                          : activeTab === "private"
                          ? "private articles"
                          : "public articles"
                      }`
                    : `Showing ${filteredNews.length} public articles`}
                </small>
              </div>
            </div>
          </div>
        </div>
        {/* News Grid */}
        <div className="row">
          {filteredNews.map((item, idx) => (
            <div
              key={item._id}
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay={`.${(idx % 3) + 3}s`}
            >
              <div className="position-relative">
                {/* Enhanced privacy badge */}
                {isAuthenticated && item.visibility === "private" && (
                  <div
                    style={{
                      position: "absolute",
                      top: "15px",
                      right: "15px",
                      zIndex: 10,
                      background: "linear-gradient(45deg, #dc3545, #e85a6b)",
                      color: "white",
                      padding: "6px 12px",
                      borderRadius: "20px",
                      fontSize: "11px",
                      fontWeight: "600",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      boxShadow: "0 2px 8px rgba(220, 53, 69, 0.3)",
                      border: "2px solid white",
                    }}
                  >
                    <i className="fa-solid fa-lock me-1"></i>
                    Private
                  </div>
                )}

                <SingleBlog
                  heading={item.title}
                  title={item.description
                    .replace(/<p>(\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, "")
                    .replace(/<img[^>]*>/g, "")
                    .replace(/<\/?(ul|ol|li)[^>]*>/g, "")}
                  publishedDate={new Date(item.date).toLocaleDateString(
                    "en-IN",
                    {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }
                  )}
                  btnClass="ed-btn-blog"
                  hasArrow
                  image={item.imageUrl?.[0]}
                  _id={item._id}
                  type="news"
                />
              </div>
            </div>
          ))}
        </div>
        {filteredNews.length === 0 && (
          <div className="row">
            <div className="col-12 text-center py-5">
              <div
                style={{
                  backgroundColor: "#e3f2fd",
                  border: "1px solid #bbdefb",
                  borderRadius: "15px",
                  padding: "30px",
                  maxWidth: "500px",
                  margin: "0 auto",
                }}
              >
                <i
                  className="fa-solid fa-newspaper"
                  style={{
                    fontSize: "48px",
                    color: "#2196f3",
                    marginBottom: "15px",
                  }}
                ></i>
                <h5 style={{ color: "#1976d2", marginBottom: "10px" }}>
                  No Articles Found
                </h5>
                <p style={{ color: "#666", margin: 0 }}>
                  {isAuthenticated
                    ? activeTab === "private"
                      ? "No private articles available at the moment."
                      : activeTab === "public"
                      ? "No public articles available at the moment."
                      : "No articles available at the moment."
                    : "No public articles available at the moment."}
                </p>
              </div>
            </div>
          </div>
        )}
        {/* Clean Pagination */}
        {filteredNews.length > 0 && (
          <div className="row mb-40">
            <div className="col-12">
              <div className="d-flex justify-content-center align-items-center">
                {/* Previous Button */}
                <button
                  onClick={() => {
                    if (canGoPrev) {
                      handlePrev();
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }
                  }}
                  disabled={!canGoPrev}
                  style={{
                    backgroundColor: canGoPrev ? "#007bff" : "#f8f9fa",
                    color: canGoPrev ? "white" : "#6c757d",
                    border: canGoPrev
                      ? "1px solid #007bff"
                      : "1px solid #dee2e6",
                    borderRadius: "8px",
                    padding: "12px 16px",
                    cursor: canGoPrev ? "pointer" : "not-allowed",
                    transition: "all 0.3s ease",
                    marginRight: "15px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: "50px",
                    height: "44px",
                  }}
                  onMouseEnter={(e) => {
                    if (canGoPrev) {
                      e.target.style.backgroundColor = "#0056b3";
                      e.target.style.transform = "translateY(-1px)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (canGoPrev) {
                      e.target.style.backgroundColor = "#007bff";
                      e.target.style.transform = "translateY(0)";
                    }
                  }}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>

                {/* Next Button */}
                <button
                  onClick={() => {
                    if (canGoNext) {
                      handleNext();
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }
                  }}
                  disabled={!canGoNext}
                  style={{
                    backgroundColor: canGoNext ? "#007bff" : "#f8f9fa",
                    color: canGoNext ? "white" : "#6c757d",
                    border: canGoNext
                      ? "1px solid #007bff"
                      : "1px solid #dee2e6",
                    borderRadius: "8px",
                    padding: "12px 16px",
                    cursor: canGoNext ? "pointer" : "not-allowed",
                    transition: "all 0.3s ease",
                    marginLeft: "15px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: "50px",
                    height: "44px",
                  }}
                  onMouseEnter={(e) => {
                    if (canGoNext) {
                      e.target.style.backgroundColor = "#0056b3";
                      e.target.style.transform = "translateY(-1px)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (canGoNext) {
                      e.target.style.backgroundColor = "#007bff";
                      e.target.style.transform = "translateY(0)";
                    }
                  }}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        )}
        {/* Enhanced Loading indicator */}
        {isFetchingNextPage && (
          <div className="row">
            <div className="col-12 text-center py-4">
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  backgroundColor: "#f8f9fa",
                  padding: "15px 25px",
                  borderRadius: "25px",
                  border: "1px solid #dee2e6",
                }}
              >
                <div
                  className="spinner-border text-primary me-3"
                  role="status"
                  style={{ width: "20px", height: "20px" }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
                <span style={{ color: "#495057", fontWeight: "500" }}>
                  Loading more articles...
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsSection;
